<!--
 * @Descripttion: 
 * @version: 弹窗信息分组标题组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2026-01-06 17:52:28
-->
<template>
  <div class="form-group">
    <div class="form-select"></div>
    <div class="form-title">{{ props.title }}</div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  /**分组标题 */
  title: string
}
const props = defineProps<Props>()
</script>
<style lang="less" scoped>
.form-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16.5px;
  margin-bottom: 10px;

  .form-select {
    width: 4px;
    height: 16px;
    background: var(--primary-color);
    margin-right: 6px;
  }

  .form-title {
    font-weight: 600;
  }
}
</style>
